import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleriaModule } from 'primeng/galleria';
import { SidePanelComponent } from '../side-panel/side-panel.component';
import { ImageComponent } from '../../foundation/image/image.component';

@Component({
  standalone: true,
  selector: 'lx-side-panel-gallery',
  templateUrl: './side-panel-gallery.component.html',
  styleUrls: ['./side-panel-gallery.component.scss'],
  imports: [GalleriaModule, SidePanelComponent, ImageComponent],
})
export class SidePanelGalleryComponent {
  @Input() visible: boolean | undefined;
  @Input() fallbackImage: string | undefined;
  validImages: string[] = [];
  @Output() hiddenPanel = new EventEmitter<void>();

  private _images: string[] = [];

  get images(): string[] {
    return this._images;
  }

  @Input() set images(value: string[]) {
    if (value && value.length) {
      this._images = value;
    } else if (this.fallbackImage) {
      this._images = [this.fallbackImage];
    } else {
      this._images = [];
    }
    this.preloadImages(this.images);
  }

  preloadImages(images: string[]) {
    this.validImages = []; // reset valid list
    images.forEach((image) => {
      const img = new Image();
      img.onload = () => {
        this.validImages.push(image);
      };
      img.onerror = () => {
        if (!this.validImages.includes(this.fallbackImage)) {
          this.validImages.push(this.fallbackImage);
        }
      };
      img.src = image;
    });
  }
}
